import { Injectable } from '@angular/core';
import { IPravnoLiceFilterDto, TipStranke } from '@kodit/core/data-api';
import { AdvancedFilterActionData } from '@kodit/core/shared-ui';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PravnoLiceFilterService {
  constructor() {}

  /**
   * Advanced filter methods
   */
  advanceFilterSubmitted$ = new BehaviorSubject<
    AdvancedFilterActionData<IPravnoLiceFilterDto>
  >(null);
  get getAdvanceFilterSubmitted() {
    return this.advanceFilterSubmitted$.asObservable();
  }
  set setAdvanceFilterSubmitted(
    data: AdvancedFilterActionData<IPravnoLiceFilterDto>
  ) {
    this.advanceFilterSubmitted$.next(data);
  }
}
